import Icon from "@ant-design/icons";
import { type FunctionComponent } from "react";

import { type IBTIconProps } from "../BTIcon.types";
import { useBaseIcon } from "../BTIcon.utilities";
import SVG from "../images/To-dos.svg?react";

export const BTIconTodos: FunctionComponent<IBTIconProps> = (baseProps) => {
    const [props] = useBaseIcon(baseProps);

    // eslint-disable-next-line react/forbid-elements
    return <Icon {...props} component={SVG} />;
};
